import React, { useState } from "react";
import { Modal, Box, Typography, Button, Checkbox, CircularProgress } from "@mui/material";
import { FaWifi } from "react-icons/fa6";
import axios from "axios";
const BE_URI = process.env.REACT_APP_BE_URI;

const WifiModulesPickerModal = ({ modalVisible, setModalVisible, wifiModules, wifiSections, setWifiSections, getWifiSections, token, buttonColor, title }) => {
  const [pickedIds, setPickedIds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleAddWifiModuleToWifiSection = async () => {
    try {
      setIsLoading(true);
      const formData = {
        wifiSection: {
          _id: modalVisible._id,
          wifiModules: [...modalVisible.wifiModules, ...pickedIds],
        },
      };

      const res = await axios.put(BE_URI + "/update-wifiSection", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      setModalVisible(false);
      setIsLoading(false);

      if (res.data.success) {
        const updatedWifiSections = wifiSections
          .filter((wS) => wS._id !== modalVisible._id)
          .concat(res.data.wifiSection)
          .sort((a, b) => a.sequence - b.sequence);

        setWifiSections(updatedWifiSections);
        getWifiSections();
      } else {
        console.error("Error:", res.data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      setModalVisible(false);
      setIsLoading(false);
    }
  };

  return (
    <Modal open={modalVisible} onClose={() => setModalVisible(false)}>
      <Box sx={{ width: 400, bgcolor: "white", p: 3, mx: "auto", mt: 10, borderRadius: 2 }}>
        <Typography variant="h6" sx={{ bgcolor: buttonColor, color: "white", p: 1, textAlign: "center" }}>
          {title ?? "Pick Wifi Modules"}
        </Typography>

        {/* Wifi Modules List */}
        <Box sx={{ maxHeight: 260, overflowY: "auto", my: 2 }}>
          {wifiModules.map((wifiModule) => (
            <Box key={wifiModule._id} sx={{ display: "flex", alignItems: "center", my: 1 }}>
              <Checkbox
                checked={pickedIds.includes(wifiModule._id)}
                onChange={() =>
                  setPickedIds((prev) =>
                    prev.includes(wifiModule._id) ? prev.filter((id) => id !== wifiModule._id) : [...prev, wifiModule._id]
                  )
                }
              />
              <FaWifi  sx={{ color: buttonColor, mr: 1 }} />
              <Typography sx={{ fontWeight: "bold" }}>{wifiModule.name}</Typography>
            </Box>
          ))}
        </Box>

        {/* Buttons */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Button variant="contained" color="error" onClick={() => setModalVisible(false)}>
            CANCEL
          </Button>

          {isLoading ? (
            <CircularProgress size={24} />
          ) : (
            <Button
              variant="contained"
              sx={{ bgcolor: buttonColor, color: "white" }}
              onClick={() => (pickedIds.length < 1 ? setModalVisible(false) : handleAddWifiModuleToWifiSection())}
            >
              {pickedIds.length < 1 ? "OK" : "SAVE"}
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default WifiModulesPickerModal;
